import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-session-timer-regulatory-bar",
	templateUrl: "./session-timer-regulatory-bar.container.html",
	styleUrls: ["./session-timer-regulatory-bar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SessionTimerRegulatoryBarContainer {
	@HostBinding("class.obg-session-timer-regulatory-bar") hostCssClass = true;
}
